module.exports = __webpack_public_path__ + "fwm_h5/img/chaxun.8833497d.png";